import { render, staticRenderFns } from "./Servicio.vue?vue&type=template&id=6fef34b8&"
import script from "./Servicio.vue?vue&type=script&lang=js&"
export * from "./Servicio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports